"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIAlert;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _H = _interopRequireDefault(require("../elements/headings/H5"));

var _AlertTypes = require("../alert/AlertTypes");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

function UIAlert(props) {
  var children = props.children,
      className = props.className,
      closeable = props.closeable,
      onClose = props.onClose,
      titleText = props.titleText,
      type = props.type,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "closeable", "onClose", "titleText", "type", "use"]);
  var computedClassName = (0, _classnames.default)("alert private-alert", _AlertTypes.ALERT_TYPES[type], className, closeable && 'private-alert--dismissable alert-dismissable', use === 'inline' && 'private-alert--inline');
  return _react.default.createElement("div", Object.assign({}, rest, {
    "aria-atomic": true,
    "aria-live": "polite",
    className: computedClassName,
    role: "alert"
  }), _react.default.createElement("div", {
    className: "private-alert__inner"
  }, titleText && _react.default.createElement(_H.default, {
    className: "private-alert__title"
  }, titleText), _react.default.createElement("div", {
    className: "private-alert__body has--vertical-spacing"
  }, children)), closeable && _react.default.createElement(_UICloseButton.default, {
    "aria-hidden": true,
    className: "close private-alert__close",
    onClick: onClose,
    size: "md"
  }));
}

UIAlert.displayName = 'UIAlert';
UIAlert.propTypes = {
  children: _propTypes.default.node,
  closeable: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func,
  titleText: _propTypes.default.node,
  type: _propTypes.default.oneOf(Object.keys(_AlertTypes.ALERT_TYPES)).isRequired,
  use: _propTypes.default.oneOf(Object.keys(_AlertTypes.ALERT_USES)).isRequired
};
UIAlert.defaultProps = {
  closeable: false,
  type: 'info',
  use: 'default'
};
module.exports = exports.default;